import clsx from "clsx";
import { bool, func, string } from "prop-types";

import classes from "./RadioButton.module.scss";

const RadioButton = ({
  checked = false,
  disabled = false,
  id,
  name,
  onChange,
  value,
}) => (
  <span
    className={clsx(
      classes.radio,
      checked && classes.checked,
      disabled && classes.disabled
    )}
  >
    <input
      checked={checked}
      className={classes.nativeInput}
      disabled={disabled}
      id={id}
      name={name}
      onChange={onChange}
      readOnly={!onChange}
      tabIndex={-1}
      type="radio"
      value={value}
    />
    <span className={classes.dot} />
  </span>
);

RadioButton.propTypes = {
  checked: bool,
  disabled: bool,
  id: string,
  name: string,
  onChange: func,
  value: string,
};

export default RadioButton;
